export default __webpack_public_path__ + "static/media/poster-sdg-10.d4842e76.png";